import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { cardConfig } from '../../model/common.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnimatedNumberComponent } from "../../components/animated-number/animated-number.component";
import { CamelCasePipe } from '../../utils/camel-case.pipe';
@Component({
  selector: 'dynamic-card-banner',
  standalone: true,
  imports: [MatCardModule, RouterModule, MatProgressSpinnerModule, AnimatedNumberComponent,CamelCasePipe],
  templateUrl: './dynamic-card-banner.component.html',
  styleUrl: './dynamic-card-banner.component.scss'
})
export class DynamicCardBannerComponent implements OnInit {
  @Input() cardConfig: Array<cardConfig> | undefined;
  public beginRender = false;

  ngOnInit(): void {
    setInterval(() => {
      this.beginRender = true;
    }, 500)

  }
}
